// removed by extract-text-webpack-plugin
module.exports = {"framer":"processing-viewer__framer___jueaV"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/processing-viewer.scss
// module id = 1372
// module chunks = 0